import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'vant/lib/index.css';
import { Swipe, SwipeItem, Lazyload, Dialog, Uploader, RadioGroup, Radio, Button, Icon, ImagePreview, Checkbox, CheckboxGroup } from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



if(process.env.NODE_ENV == "development"){
  axios.defaults.baseURL = '/api';
}

Vue.config.productionTip = false
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Dialog);
Vue.use(Uploader);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Button);
Vue.use(Icon);
Vue.use(ImagePreview);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(ElementUI);

Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
